import React from 'react'
import { RotatingLines } from "react-loader-spinner";

const Loader = ({ loading }) => {
  return (
    <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
    <RotatingLines
      strokeColor="grey"
      strokeWidth="5"
      animationDuration="0.75"
      width="40"
      visible={loading}
      ariaLabel="Loading..."
    />
    <h3 style={{color:'#CCCCCC',display:'flex',justifyContent:'center',alignItems:'center'}}>Loading...</h3>
    </div>
  )
}

export default Loader
